import { convertToNumber } from "../formatters";

export function ktsToMph(kts: number | string, fixed?: number): string {
  const unit = convertToNumber(kts);
  const converted = unit * 1.15078;
  return fixed ? converted.toFixed(fixed) : converted.toFixed(2);
}

export function kmToMiles(km: number | string, fixed?: number): string {
  const unit = convertToNumber(km);
  const converted = unit * 0.621371;
  return fixed ? converted.toFixed(fixed) : converted.toFixed(2);
}
